var React = require('react');

function MeetAndGreet (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8.291","cy":"1.297","r":"1.297","key":0}),React.createElement("path",{"d":"M9.912 3.676H5.084l-.111-.064v-.695a.267.267 0 00-.266-.266H3.31l-.722-.416a.54.54 0 00-.738.198.531.531 0 00-.067.218H.266A.267.267 0 000 2.917v2.81c0 .146.12.266.266.266h4.441c.146 0 .266-.12.266-.266v-.97h1.696c.055 0 .098.042.105.095h.003v10.931a.649.649 0 101.298 0v-5.189a.216.216 0 01.432 0v5.189a.649.649 0 101.298 0V4.865c0-.06.048-.108.108-.108s.108.048.108.108v4.756a.54.54 0 101.082 0V4.865a1.192 1.192 0 00-1.191-1.189zM4.707 5.728H.266v-2.81h4.441v2.81z","key":1})]);
}

MeetAndGreet.defaultProps = {"width":"11.101","height":"16.432","viewBox":"0 0 11.101 16.432"};

module.exports = MeetAndGreet;

MeetAndGreet.default = MeetAndGreet;
